import { SpacingStack, styled, ButtonV2 } from '@withjoy/joykit';

export const SocialAccountWrapper = styled(SpacingStack)`
  max-width: 405px;
`;

export const StyledButtonV2 = styled(ButtonV2)`
  width: fit-content;
`;
